module.exports = __webpack_public_path__ + "img/3531c2e.jpg";